import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'cattail',
      d: 'M0,-6.5h0.5v1h-0.5zM-1.5,-6h0.5v0.5h-0.5zM0,-5h1v0.5h-1zM-1,-4.5h2v0.5h-2zM-1,-4h0.5v1h-0.5zM0,-4h1v0.5h-1zM-2,-3.5h0.5v0.5h-0.5zM0,-3.5h2v1h-2zM-2,-3h1.5v1h-1.5zM0.5,-2.5h1.5v1h-1.5zM-1.5,-2h1v1.5h-1zM0.5,-1.5h1v1.5h-1zM-1,-0.5h1v1h-1zM0.5,0h0.5v0.5h-0.5z',
    },
    { paint: 'leafLight', d: 'M-0.5,-4h0.5v1.5h-0.5zM-0.5,-2.5h1v2h-1zM0,-0.5h0.5v1h-0.5z' },
    {
      paint: 'trunk',
      d: 'M0,-7h1v0.5h-1zM-1,-6.5h0.5v0.5h-0.5zM0.5,-6.5h0.5v1h-0.5zM-1,-6h1v0.5h-1zM-1,-5.5h2v0.5h-2zM-1,-5h1v0.5h-1z',
    },
  ],
  pixels: 77,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
